import React from 'react';
import styled, { css } from 'styled-components';
import { HeroImage, Container, SliderList } from 'components/elements';
import BgImage from 'assets/images/bg.jpg';
import MobileBgImage from 'assets/images/mobile-bg.jpg';
import { colors, fontType, snippet, spacer, rgba, media } from 'settings/style';
import GroupCard from 'components/groupCard';
import EventCard from 'components/eventCard';
import moment from 'moment';
import { useGetAllGroupsQuery, useGetAllEventsQuery, useGetUpcomingEventsQuery, useLoggedInStateQuery } from 'graphql/types';
// import { signupModalVisible } from 'cache';
import CategoriesList from 'components/categories/categoriesList';
// import ZCalendar from 'components/zCalendar';

const twoMonthsAgo = moment().subtract(2, 'months').toISOString();

const Home = () => {
  const { data: groupsResult, loading: groupLoading } = useGetAllGroupsQuery({
    variables: {
      filters: { status: { eq: 'approved' }, createdAt: { gte: twoMonthsAgo } },
      pagination: { start: 0, limit: 30 },
      sort: 'createdAt:desc',
    },
  });
  const { data: upcomingEvents, loading: upcomingEventsLoading } = useGetUpcomingEventsQuery();
  // const { data: newEvents, loading: newEventsLoading } = useGetAllEventsQuery({
  //   variables: { pagination: { start: 0, limit: 30 }, sort: 'createdAt:desc' },
  // });
  const { data: allEvents, loading: allEventsLoading } = useGetAllEventsQuery({
    variables: { sort: 'createdAt:desc' },
  });
  const useLoggedInStateResult = useLoggedInStateQuery();
  const isLoggedIn = useLoggedInStateResult.data?.loggedInState;
  return (
    <HomeWrapper isLoggedIn={isLoggedIn}>
      <div style={{ display: 'relative' }}>
        <HeroImage img={BgImage} mobileImg={MobileBgImage} overlay>
          <div className="hero-content">
            <h1 className="head-first">The way in the world is one</h1>
            <h1 className="head-second">
              and that way is <span>TRUTH</span>
            </h1>

            {/* <HeroCalendarWrapper centerPos={true}>
              <ZCalendar changeDate={false} />
            </HeroCalendarWrapper> */}
          </div>
        </HeroImage>
      </div>
      <ContentContainer>
        <Container>
          <CategoriesList />
          <div className="row-cont">
            <SliderList
              renderList={(props) => <EventCard {...props} bookings={props?.bookings?.data} />}
              title="Upcoming Events"
              items={upcomingEvents?.upcomingEvents || []}
              loading={upcomingEventsLoading}
            />
          </div>
          <div className="row-cont">
            <SliderList
              renderList={(props) => <EventCard {...props.attributes} />}
              title="All Events"
              items={allEvents?.events?.data || []}
              loading={allEventsLoading}
            />
          </div>
          <div className="row-cont">
            <SliderList
              renderList={(props) => <GroupCard {...props} />}
              title="Newly added Groups"
              items={groupsResult?.groups?.data || []}
              perView={3}
              loading={groupLoading}
            />
          </div>
        </Container>
      </ContentContainer>
      {/* <HeroCalendarWrapper centerPos={false}>
        <ZCalendar changeDate={false} />
      </HeroCalendarWrapper> */}
    </HomeWrapper>
  );
};
export default Home;

const ContentContainer = styled.div`
  padding: ${spacer.lg} 0;
  h3 {
    ${fontType.lg}
    ${snippet.underline()}
  }
  .row-cont {
    margin: ${spacer.xl} 0;
  }
`;

const HomeWrapper = styled.div<{ isLoggedIn: boolean }>`
  .hero-content {
    font-size: 15px;
    position: absolute;
    bottom: 5rem;
    
    ${media.md`
      font-size: 14px;
      padding: 0 ${spacer.lg};
      bottom: 1.5rem;
    `}
    ${media.xs`
      font-size: 11px;
    `}
    text-align: center;
    .head-first {
      color: ${colors.white};
      font-size: 3em;
      font-weight: 600;
      font-family: 'Cormorant Garamond';
      margin-bottom: 0;
    }
    .head-second {
      color: ${colors.white};
      font-size: 3em;
      font-weight: 700;
      font-family: 'Cormorant Garamond';
      span {
        color: ${colors.accent};
      }
    }
    .join-us-btn {
      width: 54%;
      padding: 1em 0em;
      margin-top: 1.5em;
      color: ${colors.white};
      backdrop-filter: blur(10px);
      background-color: ${rgba(colors.accent, 0.3)};
      justify-content: center;
      &:hover {
        border-color: ${colors.accent};
        background-color: ${rgba(colors.accent, 1)};
      }
    }
    /* ${({ isLoggedIn }) =>
    !isLoggedIn &&
    css`
        &:before {
          content: '';
          position: absolute;
          width: 100%;
          bottom: 1.7em;
          height: 1.5px;
          left: 0;
          background: linear-gradient(
            to right,
            ${rgba(colors.white, 0)},
            ${rgba(colors.accent, 1)},
            ${rgba(colors.white, 0)}
          );
        }
      `} */
  }
`;

// const HeroCalendarWrapper = styled.div<{ centerPos: boolean }>`
//   display: ${({ centerPos }) => (centerPos ? 'none' : 'block')};
//   position: absolute;
//   top: 100px;
//   right: 50px;
//   z-index: 10;

//   ${media.md`
//       display: flex !important;
//       justify-content: center;
//       align-items: center;
//       position: static;
//       margin-top: 7rem;
//       justify-items: center;
//   `}

//   ${({ centerPos }) => centerPos ? css`
//     ${media.md`
//       display: block;
//     `}
//   ` : css`
//     ${media.md`
//       display: none !important;
//     `}
//   `}

//   ${media.xs`
//     .dateController {
//       display: none;
//     }
//   `}
// `;
